<template>
  <main class="blog-detail">
    <header class="banner">
      <img src="../assets/images/blog-detail-placeholder.png" alt="" />
    </header>
    <article class="article">
      <section class="section">
        <h3>ContaFácil</h3>
        <h2>{{ content.title }}</h2>
        <h3>{{ date }}</h3>
        <div class="content" v-html="content.content"></div>
        <div class="social-share">
          <b>Compartir: </b>
          <div class="icons-share">
            <img src="../assets/images/icon_twitter.svg" alt />
            <img src="../assets/images/icon_facebook.svg" alt />
            <img src="../assets/images/icon_share.svg" alt />
          </div>
        </div>
      </section>
    </article>
    <section class="section recent-posts">
      <h2 class="recientes">PUBLICACIONES RECIENTES</h2>
      <blog-carrousel />
    </section>
  </main>
</template>

<script>
import BlogCarrousel from "../components/BlogCarrousel";
export default {
  name: "BlogDetail",
  components: {
    BlogCarrousel
  },
  async created() {
    // this.$modal.show("loader-root");
    // await this.$store.dispatch("getPost", this.$route.params.id);
    // this.$modal.hide("loader-root");
  },
  computed: {
    content() {
      if (!this.$store.getters.postGetter) return "";
      return this.$store.getters.postGetter;
    },
    date() {
      return new Date(this.content.createdAt).toLocaleDateString();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/general.scss";
.banner {
  width: 100%;
  img {
    width: 100%;
    height: auto;
  }
  @include tablet() {
    display: block !important;
    // max-height: 300px;
  }
}
.article {
  width: 100%;
  margin: 3rem auto;
  .section {
    text-align: start;
    max-width: 700px;
    margin: 0 auto;
    h3 {
      font-size: 1rem;
      margin: 0.5em 0;
    }
    h2 {
      font-weight: bold;
      font-size: 1.3rem;
      text-align: start;
      padding: 0;
      margin: 0.5em 0;
    }
    .content /deep/ div {
      // margin: 1rem auto;
    }
    @media (min-width: 1024px) {
      max-width: 800px;
      h3 {
        font-size: 1.5rem;
        margin: 2rem 0;
        letter-spacing: 0.1em;
      }
      h2 {
        font-weight: bold;
        font-size: 1.5rem;
        text-align: start;
        width: 50%;
        padding: 0;
      }
      .content /deep/ div {
        font-size: 1.5rem;
        // margin: 1rem auto;
      }
    }
    @media (min-width: 1400px) {
      max-width: 1000px;
      h3 {
        font-size: 1.55rem;
        margin: 2rem 0;
        letter-spacing: 0.1em;
      }
      h2 {
        font-weight: bold;
        font-size: 1.55rem;
        text-align: start;
        width: 50%;
        padding: 0;
      }
      .content /deep/ div {
        font-size: 1.55rem;
        // margin: 1rem auto;
      }
    }
    @media (min-width: 1800px) {
      max-width: 1300px;
      h3 {
        font-size: 1.8rem;
        margin: 2rem 0;
        letter-spacing: 0.1em;
      }
      h2 {
        font-weight: bold;
        font-size: 1.8rem;
        text-align: start;
        width: 50%;
        padding: 0;
      }
      .content /deep/ div {
        font-size: 1.8rem;
        // margin: 1rem auto;
      }
    }
  }
}
.social-share {
  font-style: 1rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 4em;
  .icons-share {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    img {
      height: 1em;
      width: auto;
      margin-left: 25px;
      cursor: pointer;
    }
  }
  @media (min-width: 1024px) {
    font-size: 1.2rem;
  }
  @media (min-width: 1400px) {
    font-size: 1.5rem;
  }
  @media (min-width: 1800px) {
    font-size: 1.8rem;
  }
}
h2.recientes {
  font-weight: normal;
  font-size: 1.2rem;
  text-align: start;
  width: 80%;
  max-width: 1480px;
  margin: 8em auto 4em;
  font-family: "Geometos", sans-serif;
  @media (min-width: 1024px) {
    font-size: 2rem;
    padding: 0 2rem;
  }
}
// .recent-posts {
//   margin: 15em auto 0;
// }
</style>
